import { useClose } from '@headlessui/react';

import { useTranslate } from '../../../../../../hooks/useTranslate';
import { GetTagsByMarketResult } from '../../../../../MarketPage/MarketPage.types';
import { Grid, Separator, StyledLink, StyledPanel } from './Dropdown.styles';

type Props = {
  tags: GetTagsByMarketResult;
};

export const Dropdown = ({ tags }: Props) => {
  const { t } = useTranslate();
  const close = useClose();

  return (
    <StyledPanel anchor="bottom start" transition>
      <Grid>
        {tags.map((tag) => (
          <StyledLink key={tag._id} href={`/tag/${tag.slug}`} onClick={close}>
            {tag.name}
          </StyledLink>
        ))}
      </Grid>

      <Separator />

      <StyledLink href="/tags" onClick={close}>
        {t('explore.showAllCategories')}
      </StyledLink>
    </StyledPanel>
  );
};
